export const THIRD_PARTY_PROCESS_NAME = 'third-party';

export const pluginsWhiteList = [
  'kyb',
  'ubo',
  'company_sanctions',
  'merchant_monitoring',
  'businessInformation',
  'companySanctions',
  'merchantMonitoring',
  'merchantScreening',
  'bankAccountVerification',
  'commercialCreditCheck',
  'duplication_check',
] as const;
